/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SkipFlag/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function SkipFlag({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Skip/Content/SkipFlag",
  onChange
  
}) {
let skipFlagValueValueData = fromData.useDataValue({ viewPath,
context: 'skip_flag',
path: 'value',
})
let skipFlagValueChangeData = fromData.useDataChange({ viewPath,
context: 'skip_flag',
path: 'value',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let skipFlagTextValueData = fromData.useDataValue({ viewPath,
context: 'skip_flag',
path: 'text',
})
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 marginLeft={dtSpaceS}
 data="skip_flag.value"
 value={skipFlagValueValueData}
 onChange={skipFlagValueChangeData}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 data="skip_flag.text"
 text={skipFlagTextValueData}
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}